<div class="popup-title">{{ sitecore.betslip.betslipRuleUpdatePopupUS.Title }}</div>
<div class="popup-text" [innerHTML]="sitecore.betslip.betslipRuleUpdatePopupUS.PopupText"></div>
<button ds-button class="stake-modal-popup-info-btn" size="medium" (click)="close()">
    {{ sitecore.betslip.betslipRuleUpdatePopupUS.Messages.ButtonText }}
</button>
<a class="settings-url" [href]="settingsURL">{{ sitecore.betslip.betslipRuleUpdatePopupUS.Messages.BetslipSettingsLinkText }}</a>
